// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Fui from '../src/index'
import $ from 'jQuery'
import './scss/main.scss'
import axios from 'axios';
import qs from 'qs';
import store from './store';
import { Loading } from 'element-ui'




// YSF.init('2400fc7bc81654d618866cdc95c0a9c0', {
//   templateId: 123, // templateId表示自定义会话邀请的模板标识
//   shuntId: 123, // shuntId表示访客选择多入口分流模版id
//   sessionInvite: false, // sessionInvite表示是否开启会话邀请设置
//   hidden: 2 // hidden表示是否隐藏访客端默认入口
// }).then(ysf => {
//   ysf('open');
// }).catch(error => {
//   console.log('sdk加载失败---', error);
// });

//import VueRouter from 'vue-router';
// import { TweenMax, TimelineMax, TweenLite } from 'gsap'
Vue.use(Fui);
//Vue.use(VueRouter);
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service

Array.prototype.indexOf = function(val) {
	for (var i = 0; i < this.length; i++) {
		if (this[i] == val) return i;
	}
	return -1;
};
Array.prototype.remove = function(val) {
	var index = this.indexOf(val);
	if (index > -1) {
		this.splice(index, 1);
	}
};
String.prototype.strWidth = function() {
	var width = (this) ? (this.replace(/[^x00-xff]/g, '00').length / 2) : 0
	return width;
}
Vue.config.productionTip = false

Vue.filter('sp', function(value) {
})

Vue.prototype.commonDom = {
    /* 选择元素 */
    $:function (arg, context) {
        var tagAll, n, eles = [], i, sub = arg.substring(1);
        context = context || document;
        if (typeof arg == 'string') {
            switch (arg.charAt(0)) {
                case '#':
                    return document.getElementById(sub);
                    break;
                case '.':
                    if (context.getElementsByClassName) return context.getElementsByClassName(sub);
                    tagAll = this.$('*', context);
                    n = tagAll.length;
                    for (i = 0; i < n; i++) {
                        if (tagAll[i].className.indexOf(sub) > -1) eles.push(tagAll[i]);
                    }
                    return eles;
                    break;
                default:
                    return context.getElementsByTagName(arg);
                    break;
            }
        }
    },

    /* 绑定事件 */
    on:function (node, type, handler) {
        if(node) {
            node.addEventListener ? node.addEventListener(type, handler, false) : node.attachEvent('on' + type, handler);
        }
    },

    /* 获取事件 */
    getEvent:function(event){
        return event || window.event  || arguments.callee.caller.arguments[0];
    },

    /* 获取事件目标 */
    getTarget:function(event){
        return event.target || event.srcElement;
    },

    /* 获取元素位置 */
    getPos:function (node) {
        var scrollx = document.documentElement.scrollLeft || document.body.scrollLeft,
            scrollt = document.documentElement.scrollTop || document.body.scrollTop;
        var pos = node.getBoundingClientRect();
        return {top:pos.top + scrollt, right:pos.right + scrollx, bottom:pos.bottom + scrollt, left:pos.left + scrollx }
    },

    /* 添加样式名 */
    addClass:function (cls, elem) {
      cls = cls || '';
      if (cls.replace(/\s/g, '').length == 0) return false; //当cls没有参数时，返回false
      var nameList=elem.className.split(" ");
      if(nameList.indexOf(cls)==-1){
        elem.className=elem.className+" "+cls;
      }
      /*else{
         elem.className=elem.className;
      }
      console.log(nameList)
      return new RegExp(' ' + cls + ' ').test(' ' + elem.className + ' ');  */    
    },

    /* 移除样式名 */
    removeClass:function (c, node) {
        var reg = new RegExp("(^|\\s+)" + c + "(\\s+|$)", "g");
        if(!this.hasClass(c,node))return;
        var nameList=node.className.split(" ");
        if(nameList.indexOf(c)>-1){
          node.className="";  
          nameList.forEach(function(v){
             if(v!=c&&v!=""){
                node.className+=(v+" ");    
             }       
          })  
          //elem.className=elem.className+" "+cls;
        };
       // node.className = reg.test(node.className) ? node.className.replace(reg, '') : node.className;

    },

    /* 是否含有CLASS */
    hasClass:function (c, node) {
        if(!node || !node.className || node.className=="")return false;
        return node.className.indexOf(c)>-1;
    },

    /* 阻止冒泡 */
    stopPropagation:function (event) {
        event = event || window.event || arguments.callee.caller.arguments[0];
        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
    },
    /* 去除两端空格 */
    trim:function (str) {
        return str.replace(/^\s+|\s+$/g,'');
    },
    getClassNames:function(classStr,tagName){  
      if (document.getElementsByClassName) {  
            return document.getElementsByClassName(classStr)  
      }else {  
            var nodes = document.getElementsByTagName(tagName),ret = [];           
            for(i = 0; i < nodes.length; i++) {
                 if(hasClass(classStr,nodes[i])){
                        ret.push(nodes[i])
                 }  
            }  
            return ret;
       }  
    }  
};


var host = window.location.host

if (process.env.NODE_ENV === 'production') {
//   axios.defaults.baseURL = 'http://' + host + '/fangcang-gdp-web';
  axios.defaults.baseURL = '/fangcang-gdp-web';
}else {
    // axios.defaults.baseURL = 'https://devenv.fangcang.com/fangcang-gdp-web';
    axios.defaults.baseURL = 'https://testenv.fangcang.com/fangcang-gdp-web';
    //axios.defaults.baseURL = 'http://local.fangcang.com:18080/fangcang-gdp-web';
    //axios.defaults.baseURL = '/api';
    // axios.defaults.baseURL = 'http://test02.fangcang.com/fangcang-gdp-web';
    // axios.defaults.baseURL = 'http://titantmc.fangcang.com/fangcang-gdp-web'; // 预发布
}

Vue.prototype.$ajax = axios;
router.beforeEach((to, from, next) => {
	Fui.LoadingBar.start();
	next();
});
//
router.afterEach((to, from, next) => {
	Fui.LoadingBar.finish();
	window.scrollTo(0,0);
});

axios.defaults.timeout = 60000
axios.interceptors.request.use(config => {
	return config
}, error => {
	console.log('加载超时');
	return Promise.reject(error)
})
axios.interceptors.response.use(response => {
	if(response.data.failCode == '302'){
        localStorage.clear();
        this.$store.state['isLogin'] = 0;
		router.push('/login/loginHome');
	}
	if(response.data.result == 0 && response.data.failReason) {	 
        if(response.data.failCode == '013330115'){
        var str = '<p>提示：当前用户无支付权限，可能存在无权限原因：</p><p>1.商家未开通泰坦金融</p><p>2.商家关闭泰坦金融收银台</p>'
        Fui.Notify.open({content: str,type: 'warning', placement: 'top-center',});
        }else{
        Fui.Notify.open({content: response.data.failReason,type: 'warning', placement: 'top-center',});
        }		
	}
	return response
}, error => {
	Fui.Notify.open({content:"加载失败！",type: 'warning', placement: 'top-center',});
	return Promise.reject(error)
})

// window.alert = function () {
//   console.warn('[百度地图] 拦截了 alert 弹窗');
// };


Vue.directive('title', {
	inserted: function (el, binding) {
	    document.title = el.innerText
	    el.remove()
	}
})
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: { App },
})


// WEBPACK FOOTER //
// ./docs/main.js